import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography,
    Grid
} from '@mui/material';
import PartnerModalConatiner from '../../containers/common/form/modal/PartnerModalConatiner';
// 🔒 부모 컴포넌트로부터 주소창 일치 여부(isLocationValid)를 정상 수신합니다.
const ActivityRegisterModal = ({ open, onClose, selectedDate, editData, onSave, onDelete, isLocationValid = false }) => {
    // 폼 상태 관리
    const [openClient, setOpenClient] = useState(false);
    const [formData, setFormData] = useState({
        activityId: null,
        usrNm: '',
        usrUuid: '',
        title: '',
        startDate: '',
        startTime: '09:00',
        endDate: '',
        endTime: '18:00',
        meetPlace: '',
        companyUuid: '',
        companyNm:'',
        content: '',
    });

    const handleOpenClient = () => {
        setOpenClient(true);
    };
    const handleCloseClient = () => {
        setOpenClient(false);
    };

    // 달력에서 날짜를 선택해 모달이 열릴 때마다 날짜 및 세션 유저 초기값 직접 매핑
    useEffect(() => {
        if (open) {
            let sessionUsrNm = '담당자 정보 없음';
            let sessionUsrUuid = '';

            const localUser = localStorage.getItem('user');

            if (editData) {
                const parsedUser = JSON.parse(localUser);
                // 🔍 1. 상세 조회 및 수정 모드일 때 (넘겨받은 데이터 바인딩)
                setFormData({
                    activityId: editData.activityId || null,
                    usrNm: editData.usrNm || '',
                    usrUuid: editData.usrUuid || '',
                    title: editData.title || '',
                    startDate: editData.startDate || '',
                    startTime: editData.startTime || '09:00',
                    endDate: editData.endDate || '',
                    endTime: editData.endTime || '18:00',
                    companyUuid: editData.companyUuid || '',
                    companyNm: editData.companyNm || '',
                    meetPlace: editData.meetPlace,
                    content: editData.content || '',
                });
            } else {
                // 🔍 2. 신규 등록 모드일 때 (로컬스토리지 직접 참조하여 즉시 주입)
                if (localUser) {
                    try {
                        const parsedUser = JSON.parse(localUser);
                        sessionUsrNm = parsedUser.usrNm || '담당자 정보 없음';
                        sessionUsrUuid = parsedUser.userUuid || parsedUser.usrUuid || '';
                    } catch (e) {
                        console.error('모달 내부 로컬스토리지 user 파싱 에러:', e);
                    }
                }

                setFormData({
                    activityId: null,
                    usrNm: sessionUsrNm,
                    usrUuid: sessionUsrUuid,
                    title: '',
                    startDate: selectedDate || '',
                    startTime: '09:00',
                    endDate: selectedDate || '',
                    endTime: '18:00',
                    companyUuid: '',
                    companyNm: '',
                    meetPlace: '',
                    content: '',
                });
            }
        }
    }, [selectedDate, editData, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        if (!formData.title || !formData.companyUuid || !formData.content) {
            alert('제목, 업체명, 내역을 모두 입력해주세요.');
            return;
        }
        onSave(formData);
        handleClose();
    };

    const handleDeleteClick = () => {
        if (formData.activityId && typeof onDelete === 'function') {
            onDelete(formData.activityId);
            handleClose();
        }
    };

    const handleClose = () => {
        setFormData({
            activityId: null,
            usrNm: '',
            usrUuid: '',
            title: '',
            startDate: '',
            startTime: '09:00',
            endDate: '',
            endTime: '18:00',
            companyUuid: '',
            companyNm: '',
            meetPlace: '',
            content: '',
        });
        onClose();
    };

    const selectedClient = (partner) => {
        // 🚀 [에러 해결 핵심]: formData가 일반 State일 때는 아래처럼 직접 객체를 복사해서 값을 변경해야 합니다.
        if (typeof formData.setFieldValue === 'function') {
            // 만약 Formik 구조가 맞다면 기존 방식 유지 (방어 코드)
            formData.setFieldValue('companyUuid', partner.partnerUuid);
            formData.setFieldValue('companyNm', partner.partnerNm);
        } else {
            // 🔥 일반 State 구조일 때: setFormData(또는 명시된 상태 변경 함수)를 호출하여 업데이트합니다.
            // 만약 상단에 상태 변경 함수명이 setFormData 라면 아래 주석을 풀고 맞춰주세요.
            if (typeof setFormData === 'function') {
                setFormData(prev => ({
                    ...prev,
                    companyUuid: partner.partnerUuid,
                    companyNm: partner.partnerNm,
                }));
            } else {
                // setFormData가 없을 경우 직접 객체 속성에 주입하는 전통적 방식 (컴포넌트 구조에 맞춰 작동)
                formData.companyUuid = partner.partnerUuid;
                formData.companyNm = partner.partnerNm;
                
                // 💡 만약 부모나 상단에서 강제 리렌더링을 일으켜야 한다면 변수 조율이 필요합니다.
                // 현재 코드 기준 강제 대입 처리로 1차 조치 완료
            }
        }
    };


    // 네이티브 인풋 창 기본 스타일
    const inputStyle = {
        border: 'none',
        background: 'transparent',
        outline: 'none',
        fontFamily: 'inherit',
        fontSize: '0.95rem',
        color: '#3c4043',
        padding: '4px 0',
        width: '100%',
    };
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            {/* MUI v5 중첩 마크업 오류(validateDOMNesting) 해결: component="span" 도입 */}
            <DialogTitle sx={{ fontWeight: 'bold', pb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" component="span" sx={{ fontWeight: 'bold' }}>
                    {formData.activityId ? '영업활동기록 상세' : '영업활동기록 등록'}
                </Typography>
            </DialogTitle>
            
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: 1.5 }}>
                    
                    {/* 활동 제목 */}
                    <TextField
                        label="제목"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        placeholder="예: 프로젝트 킥오프 미팅"
                        fullWidth
                        size="small"
                        required
                        InputProps={{ readOnly: !isLocationValid }} // 🔒 지정 경로 아닐 때 수정 차단
                    />

                    {/* 담당자 (ReadOnly) */}
                    <TextField
                        label="담당자"
                        name="usrNm"
                        value={formData.usrNm}
                        disabled
                        fullWidth
                        variant="outlined"
                        size="small"
                    />

                    {/* 📅 시작 일시 */}
                    <Box sx={{ position: 'relative', mt: 0.5 }}>
                        <Typography 
                            variant="caption" 
                            sx={{ 
                                position: 'absolute', left: '12px', top: '-8px', backgroundColor: '#fff', px: '5px',
                                color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem', fontWeight: 400, zIndex: 1, pointerEvents: 'none'
                            }}
                        >
                            시작일시
                        </Typography>
                        <Box sx={{ 
                            display: 'flex', alignItems: 'center', gap: 1.5,
                            border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '4px', padding: '8.5px 14px',
                            backgroundColor: !isLocationValid ? '#f5f5f5' : '#fff', // 🔒 지정 경로 아닐 때 배경색 회색 처리
                            '&:hover': { borderColor: !isLocationValid ? 'rgba(0, 0, 0, 0.23)' : 'rgba(0, 0, 0, 0.87)' },
                            '&:focus-within': isLocationValid ? { borderColor: '#1976d2', borderWidth: '2px', padding: '7.5px 13px' } : {}
                        }}>
                            <input
                                type="date"
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleChange}
                                style={inputStyle}
                                disabled={!isLocationValid} // 🔒 지정 경로가 아닐 때 선택 차단
                            />
                            <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontSize: '0.9rem', userSelect: 'none' }}>|</Typography>
                            <input
                                type="time"
                                name="startTime"
                                value={formData.startTime}
                                onChange={handleChange}
                                step="600"
                                style={{ ...inputStyle, width: '125px' }}
                                disabled={!isLocationValid} // 🔒 지정 경로가 아닐 때 선택 차단
                            />
                        </Box>
                    </Box>

                    {/* 📅 종료 일시 */}
                    <Box sx={{ position: 'relative', mt: 0.5 }}>
                        <Typography 
                            variant="caption" 
                            sx={{ 
                                position: 'absolute', left: '12px', top: '-8px', backgroundColor: '#fff', px: '5px',
                                color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem', fontWeight: 400, zIndex: 1, pointerEvents: 'none'
                            }}
                        >
                            종료일시
                        </Typography>
                        <Box sx={{ 
                            display: 'flex', alignItems: 'center', gap: 1.5,
                            border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '4px', padding: '8.5px 14px',
                            backgroundColor: !isLocationValid ? '#f5f5f5' : '#fff', // 🔒 지정 경로 아닐 때 배경색 회색 처리
                            '&:hover': { borderColor: !isLocationValid ? 'rgba(0, 0, 0, 0.23)' : 'rgba(0, 0, 0, 0.87)' },
                            '&:focus-within': isLocationValid ? { borderColor: '#1976d2', borderWidth: '2px', padding: '7.5px 13px' } : {}
                        }}>
                            <input
                                type="date"
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleChange}
                                style={inputStyle}
                                disabled={!isLocationValid} // 🔒 지정 경로가 아닐 때 선택 차단
                            />
                            <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontSize: '0.9rem', userSelect: 'none' }}>|</Typography>
                            <input
                                type="time"
                                name="endTime"
                                value={formData.endTime}
                                onChange={handleChange}
                                step="600"
                                style={{ ...inputStyle, width: '125px' }}
                                disabled={!isLocationValid} // 🔒 지정 경로가 아닐 때 선택 차단
                            />
                        </Box>
                    </Box>

                    {/* 업체명 */}
                    {/* 🚀 [정렬 보정]: 업체 입력창과 버튼이 세로로 꺾이지 않고 가로 일직선으로 예쁘게 배치되도록 컨테이너 그리드를 생성합니다. */}
                    {/* 🚀 [한 줄 고정 핵심 1]: 줄바꿈을 원천 차단(nowrap)하고 가로 플렉스로 부드럽게 정렬합니다. */}
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            flexDirection: 'row', 
                            flexWrap: 'nowrap', 
                            alignItems: 'center', 
                            gap: '8px', // 인풋창과 버튼 사이의 정갈한 간격
                            width: '100%',
                            boxSizing: 'border-box'
                        }}
                    >
                        {/* 🚀 [한 줄 고정 핵심 2]: 인풋창이 우측 버튼 공간을 제외한 남은 공간을 알아서 100% 꽉 채웁니다. */}
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                            <TextField
                                label="업체"
                                name="companyNm" 
                                value={formData.companyNm || ''} 
                                placeholder="고객사를 선택하세요."
                                fullWidth
                                size="small"
                                required
                                InputProps={{ 
                                    readOnly: !isLocationValid || true 
                                }} 
                            />
                            
                            {/* 백엔드 전송용 히든 필드 */}
                            <input 
                                type="hidden" 
                                name="companyUuid" 
                                value={formData.companyUuid || ''} 
                            />
                        </Box>

                        {/* 🚀 [한 줄 고정 핵심 3]: 버튼은 모바일에서도 절대 크기가 줄어들거나 찌그러지지 않고 고유 형태를 보존합니다. */}
                        <Box sx={{ flexShrink: 0 }}>
                            <Button
                                color="secondary"
                                variant="outlined"
                                size="small"
                                onClick={handleOpenClient}
                                disabled={!isLocationValid} 
                                sx={{ 
                                    height: '40px', 
                                    whiteSpace: 'nowrap', // 글자가 아래로 꺾이는 현상 방지
                                    px: '12px', // 모바일 폭에 맞춘 최적화 여백
                                    fontSize: '0.8rem' // 모바일 가독성 맞춤 폰트 스케일
                                }} 
                            >
                                고객사 선택
                            </Button>
                        </Box>
                    </Box>


                    {/* 업체명 */}
                    
                    <TextField
                        label="장소"
                        name="meetPlace"
                        value={formData.meetPlace}
                        onChange={handleChange}
                        placeholder="예: 에이치씨인포"
                        fullWidth
                        size="small"
                        required
                        InputProps={{ readOnly: !isLocationValid }} // 🔒 지정 경로 아닐 때 수정 차단
                    />
                    {/* 활동 내역 */}
                    <TextField
                        label="내용"
                        name="content"
                        value={formData.content}
                        onChange={handleChange}
                        placeholder="내용을 상세히 입력하세요."
                        multiline
                        rows={4}
                        fullWidth
                        size="small"
                        required
                        InputProps={{ readOnly: !isLocationValid }} // 🔒 지정 경로 아닐 때 수정 차단
                    />
                </Box>
            </DialogContent>
            
            {/* 하단 액션 버튼 바 */}
            <DialogActions sx={{ px: 3, py: 2, justifyContent: (formData.activityId && isLocationValid) ? 'space-between' : 'flex-end' }}>
                {/* 🔒 올바른 주소이고, 수정 모드일 때만 하단 왼쪽에 [삭제] 버튼 노출 */}
                {formData.activityId && isLocationValid && (
                    <Button onClick={handleDeleteClick} color="error" variant="outlined">
                        삭제
                    </Button>
                )}
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={handleClose} color="inherit" variant="outlined">
                        {isLocationValid ? '취소' : '닫기'}
                    </Button>
                    
                    {/* 🔒 올바른 주소일 때만 [저장] 버튼 활성화 노출 */}
                    {isLocationValid && (
                        <Button onClick={handleSubmit} color="primary" variant="contained">
                            저장
                        </Button>
                    )}
                </Box>
            </DialogActions>
            {openClient && (
                <PartnerModalConatiner
                    link
                    title="고객사 선택"
                    open={openClient}
                    handleClose={handleCloseClient}
                    selectedPartner={selectedClient}
                    selectedPartnerTyp={'고객사'}
                    isModal={true}
                />
            )}
        </Dialog>
    );
};

export default ActivityRegisterModal;
